import React, { FC } from 'react';
import { WizardStepIndicator } from 'src/components/widgets/wizardStepIndicator';
import { T } from 'src/shared/helpers';

/**
 * The user-facing stages of the "Set as Master Integration" switch journey. The flow is driven by a chain of
 * dialogs and full-page redirects (see useSalesChannelSwitch); each dialog renders the indicator for its own stage,
 * so the seller sees one consistent wizard across the whole journey.
 */
export enum SwitchWizardStep {
    Review = 0,
    // Payment step disabled — the switch flow now skips straight from Review to Subscription.
    // The remaining steps are renumbered so the wizard indicator has no visible gap.
    // Payment = 1,
    Subscription = 1,
    SwitchProducts = 2
}

const stepLabels = (): string[] => [T._('Review', 'Admin'), /* Payment step disabled */ T._('Subscription', 'Admin'), T._('Switch products', 'Admin')];

/** Linear progress: every step before the active one is marked complete. */
const completedUpTo = (step: SwitchWizardStep): boolean[] => stepLabels().map((_, i) => i < step);

/** The switch flow's binding of the shared wizard indicator. */
export const SwitchWizardStepIndicator: FC<{ step: SwitchWizardStep }> = ({ step }) => (
    <WizardStepIndicator steps={stepLabels()} currentStep={step} completedSteps={completedUpTo(step)} />
);
